// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:03:51

export default {
  "id": "incredible-kids-dentist",
  "slug": "incredible-kids-dentist",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/78fabd7084bc471d852345ea3891d32a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/78fabd7084bc471d852345ea3891d32a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Incredible Kids Dentist",
      "description": "This is a dentist game for kids. Have you ever wanted to be a dentist? If this was your dream before, you should not miss this game. In this educational game, you can become a doctor in a hospital. You need to check the teeth of your patients.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Educational"
      ],
      "tags": [
        "dentist",
        "doctor",
        "hospital",
        "kidgames"
      ]
    },
    "zh-CN": {
      "title": "不可思议的儿童牙医",
      "description": "这是一款儿童牙医游戏。你有没有想过成为牙医？如果这是你的梦想，那么你绝对不能错过这款游戏。在这款教育游戏中，你可以成为医院的一名医生。你需要检查患者的牙齿。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "教育性的"
      ],
      "tags": [
        "牙医",
        "医生",
        "医院",
        "儿童游戏"
      ]
    },
    "zh-TW": {
      "title": "難以置信的兒童牙醫",
      "description": "這是一款兒童牙醫遊戲。你曾經想要成為一名牙醫嗎？如果這是你的夢想，那麼你不應該錯過這款遊戲。在這款教育遊戲中，你可以成為一家醫院的醫生。你需要檢查病人的牙齒。",
      "instructions": "鼠标點擊或觸控即可遊玩",
      "genres": [
        "教育性"
      ],
      "tags": [
        "牙醫",
        "醫生",
        "醫院",
        "兒童遊戲"
      ]
    },
    "zh-HK": {
      "title": "難置信的兒童牙科醫生",
      "description": "這是一款適合兒童的牙醫遊戲。你曾經想要成為一名牙醫嗎？如果這是你的夢想，那麼你絕對不能錯過這款遊戲。在這款教育遊戲中，你可以成為一家醫院的醫生。你需要檢查病人的牙齿。",
      "instructions": "滑鼠點擊或輕觸以遊玩",
      "genres": [
        "教育性"
      ],
      "tags": [
        "牙醫",
        "醫生",
        "醫院",
        "兒童遊戲"
      ]
    },
    "ja": {
      "title": "信じられない子どもたちの歯科医者",
      "description": "これは子供向けの歯科ゲームです。歯科医になりたいと思ったことはありますか？これがあなたの夢であれば、このゲームを逃がすべきではありません。この教育ゲームでは、病院で医師になることができます。患者の歯を診察する必要があります。",
      "instructions": "マウスクリックまたはタップしてゲームを始めます",
      "genres": [
        "教育用"
      ],
      "tags": [
        "歯科医",
        "医師",
        "病院",
        "子供向けゲーム"
      ]
    },
    "ko": {
      "title": "인크레이블 키즈 드엔티스트",
      "description": "이것은 아이들을 위한 의사 게임입니다. 의사가 되고 싶었나요? 이것이 당신의 꿈이었다면, 이 게임을 놓치지 마세요. 이 교육 게임에서 병원의 의사가 될 수 있습니다. 당신의 환자들의 치아를 검사해야 합니다.",
      "instructions": "마우스 클릭이나 탭하여 게임을 시작하세요",
      "genres": [
        "교육적인"
      ],
      "tags": [
        "의사",
        "치과의사",
        "병원",
        "아이용 게임"
      ]
    },
    "fr": {
      "title": "Incroyable Dentiste pour les Enfants",
      "description": "C'est un jeu de dentiste pour enfants. As-tu déjà voulu être un dentiste ? Si c'était ton rêve avant, tu ne devrais pas manquer ce jeu. Dans ce jeu éducatif, tu peux devenir un docteur dans un hôpital. Tu dois vérifier les dents de tes patients.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Éducatif"
      ],
      "tags": [
        "dentiste",
        "docteur",
        "hôpital",
        "jeux pour enfants"
      ]
    }
  }
};
